import { Component } from 'react';
import { connect } from 'react-redux';
import env from '../../common/constants/environment';
import asyncPoll from 'react-async-poll';
import { pollRequested } from './actions';

class AsyncPollWrapped extends Component {
    render() {
        return null;
    }
}

const onPollInterval = (props, dispatch) => {
	return dispatch(pollRequested());
};

var AsyncPoll = AsyncPollWrapped;

if (env.ASYNC_POLL_INTERVAL !== 0) {
    AsyncPoll = asyncPoll(env.ASYNC_POLL_INTERVAL * 1000, onPollInterval)(AsyncPoll);
}

export default connect()(AsyncPoll);


